import { Component, OnInit, OnChanges, Input, Inject, PLATFORM_ID } from '@angular/core';
import { TypesenseService } from '../../services/typesense.service';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

interface Holding {
   id?: number;
   logo?: string;
   name?: string;
   symbol?: string;
   percent?: number;
   cbaStatus?: string;
   isin?: string;
   ranking?: number;
   shariahStates?: string;
}

@Component({
    selector: 'app-etf-screening-detailed-report',
    templateUrl: './etf-screening-detailed-report.component.html',
    styleUrls: ['./etf-screening-detailed-report.component.scss'],
    standalone: false
})
export class EtfScreeningDetailedReportComponent implements OnInit, OnChanges {
   @Input() symbol!: string;

   private subscriptions: Subscription[] = [];
   page = 1;
   pageSize = 10;
   collectionSize!: number;
   holdings: any[] = [];
   loader: boolean = false;
   private isBrowser: boolean;

   constructor(private typesenseService: TypesenseService,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
   }

   ngOnChanges() {}

   ngOnInit(): void {
      this.etfHoldings();
   }

   private etfHoldings() {
      this.loader = true;
      let symbol = this.symbol;
      let subscribe = this.typesenseService
         .etfHoldings(symbol)
         .subscribe(async (data: any) => {
            var holdingsArr = data.items;

            holdingsArr = holdingsArr.sort(
               (a: any, b: any) => b.percent - a.percent
            );
            this.holdings = holdingsArr;
            this.collectionSize = this.holdings.length;
            const symbols = this.holdings.map((holding) => holding.symbol);
            this.typesenseService.getCompanyProfileAndDataFromSymbols(symbols, false, true).then((data: any) => {
               this.holdings = this.holdings.map((holding) => {
                  return {
                     ...holding,
                     logo: data[holding.symbol]?.logo || '',
                     sharia_compliance: data[holding.symbol]?.sharia_compliance || '',
                     ranking: data[holding.symbol]?.ranking || 0,
                     ranking_v2: data[holding.symbol]?.ranking_v2 || 0
                  }
               });
               this.loader = false;
            }).catch((error: any) => {
               this.loader = false;
            });
         });
      this.subscriptions.push(subscribe);
   }


   public setEtfLocation(holding: any) {
      if (this.isBrowser) {
         if (holding.symbol) {
            window.location.href = '/stock/' + holding.symbol;
         }
      }
   }

   getstatuscolorClasses(status: any) {
      return {
         green: status === 'PASS',
         red: status === 'FAIL',
      };
   }
   // refreshHoldings() {
   //   this.holdings
   //     .map((holding, i) => ({id: i + 1, ...holding}))
   //     .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
   // }
}
